export default __webpack_public_path__ + "static/media/01.3816c2c2.jpg";